import { render, staticRenderFns } from "./email-social.vue?vue&type=template&id=34940ae7&scoped=true&"
import script from "./email-social.vue?vue&type=script&lang=js&"
export * from "./email-social.vue?vue&type=script&lang=js&"
import style0 from "./email-social.vue?vue&type=style&index=0&id=34940ae7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34940ae7",
  null
  
)

export default component.exports